import { Component, Inject, Input, Optional } from '@angular/core';

import {
  DEFAULT_NGX_LOADING_CONFIG,
  NGX_LOADING_CONFIG,
  NgxLoadingConfig
} from './ngx-loading.config';

@Component({
  standalone: false,
  selector: 'ngx-loading',
  template: `
    <div
      *ngIf="show"
      class="ngx-loading-overlay"
      [class.ngx-loading-fullscreen]="resolvedConfig.fullScreenBackdrop"
      [style.background-color]="resolvedConfig.backdropBackgroundColour"
      [style.border-radius]="resolvedConfig.backdropBorderRadius"
    >
      <div class="ngx-loading-spinner"></div>
    </div>
  `,
  styles: [
    `
      :host {
        position: relative;
        display: block;
      }

      .ngx-loading-overlay {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      }

      .ngx-loading-fullscreen {
        position: fixed;
      }

      .ngx-loading-spinner {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 4px solid rgba(255, 255, 255, 0.35);
        border-top-color: #ffffff;
        animation: ngxLoadingSpin 0.8s linear infinite;
      }

      @keyframes ngxLoadingSpin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `
  ]
})
export class NgxLoadingComponent {
  @Input() show = false;
  @Input() config?: Partial<NgxLoadingConfig>;

  constructor(
    @Optional() @Inject(NGX_LOADING_CONFIG) private readonly moduleConfig?: Partial<NgxLoadingConfig>
  ) {}

  get resolvedConfig(): NgxLoadingConfig {
    return {
      ...DEFAULT_NGX_LOADING_CONFIG,
      ...(this.moduleConfig ?? {}),
      ...(this.config ?? {})
    };
  }
}
